import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Angular2TokenService } from 'angular2-token';
import { User } from "@models/user";

@Component({
  selector: 'main',
  templateUrl: './main.pug',
})
export class MainComponent implements OnInit {

  isSignedIn: boolean = this.tokenService.userSignedIn();

  constructor(
    private tokenService: Angular2TokenService,
    private router: Router,
  ) {}

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/main.ts